import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CUSTOM_ICON_TYPE } from '@shared/models';

@Component({
  selector: 'sd-time-slot-groups-info',
  templateUrl: './time-slot-groups-info.component.html',
  styleUrls: ['./time-slot-groups-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SdvorTimeSlotGroupsInfoComponent {
  iconType = CUSTOM_ICON_TYPE;
}
